<template>
  <div>
    <v-card class="mx-auto mb-6" flat>
      <v-card-text>
        <v-alert dense text type="info" class="mt-3 mb-5 mx-3">
          <div class="black--text font-weight-medium">Informasi Pengisian:</div>
          <ol class="black--text" style="padding-inline-start: 20px">
            <li>
              Data Peserta yang dinilai sesuai dengan Data Sasaran Peserta pada IHT Pelaksanaan
            </li>
            <li>
              Semua kolom isian wajib diisi. Jika terdapat peserta yang tidak meingikuti salah satu ujian, silahkan
              kolom nilai diisi dengan angka 0.
            </li>
          </ol>
        </v-alert>
        <div class="mx-3">
          <strong style="font-size: 18px">Sasaran Peserta IHT</strong>
          <v-divider class="primary" style="height: 2.5px; max-height: 2.5px" />
        </div>
        <v-container>
          <v-list>
            <v-list-item class="px-0" v-for="(ptk, id) in kandidat" :key="id">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" lg="3" class="my-auto">
                    <div class="body-1 font-weight-medium">{{ ptk.nama || '' }}</div>
                    <div class="body-2 black--text"><span class="grey--text">NUPTK: </span>{{ ptk.nuptk || '-' }}</div>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <div class="v-subheader theme--light px-0 body-2 indigo--text" style="height: 24px;">
                      Nilai Pretest <span class="red--text ml-1">*</span>
                    </div>
                    <validation-provider
                      mode="passive"
                      :name="`Nilai Pretest Peserta ke-${id + 1}`"
                      :rules="{ required: true }"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="kandidat[id]['n_pretest']"
                        placeholder="Tuliskan nilai"
                        :disabled="readOnly"
                        outlined
                        dense
                        hide-details
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" lg="3">
                    <div class="v-subheader theme--light px-0 body-2 indigo--text" style="height: 24px;">
                      Nilai PostTest <span class="red--text ml-1">*</span>
                    </div>
                    <validation-provider
                      mode="passive"
                      :name="`Nilai PostTest Peserta ke-${id + 1}`"
                      :rules="{ required: true }"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        v-model="kandidat[id]['n_posttest']"
                        placeholder="Tuliskan nilai"
                        :disabled="readOnly"
                        outlined
                        dense
                        hide-details
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'FormKandidatUjian',
  components: { ValidationProvider },
  props: {
    title: {
      type: String,
      default: '',
    },
    childId: {
      type: [String, Number],
      default: null,
    },
    initValue: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      kandidat: [],
    };
  },
  methods: {
    reset() {
      this.$set(this, 'kandidat', []);

      const pspMonevPartisipan = this.$getDeepObj(this.initValue, 'psp_monev_partisipans') || [];
      for (const partisipan of pspMonevPartisipan) {
        this.addPartisipan(partisipan);
      }
    },

    addPartisipan(data = {}) {
      const nuptk = data.nuptk || this.$getDeepObj(data, 'ptk.nuptk') || '';

      this.kandidat.push({
        nuptk: nuptk || '',
        nama: data.nama || '',
        psp_monev_partisipan_id: data.psp_monev_partisipan_id || '',
        n_pretest: data.n_pretest !== null ? data.n_pretest || 0 : '',
        n_posttest: data.n_posttest !== null ? data.n_posttest || 0 : '',
      });
    },

    getValue() {
      return this.kandidat.map((ptk) => {
        return {
          psp_monev_partisipan_id: ptk.psp_monev_partisipan_id || '',
          n_pretest: ptk.n_pretest || '',
          n_posttest: ptk.n_posttest || '',
        };
      });
    },
  },
};
</script>

<style scoped></style>
